import React from 'react';
import PropTypes from 'prop-types';
import { Button, Row, Col } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

import { connect } from '../../../reducers/index';
import SubNavigation from '../../../components/SubNavigation';
import { url } from '../../../constants/routes';
import EducationModuleLayout from '../../../components/Layout/EducationModuleLayout';
import UnClickableScreenReader from '../../../components/ScreenReader/UnClickableScreenReader';

import './styles.css';
// import ReferGraphic from '../img/refer-graphic.svg';

const ReferPage = props => {
  const { role } = props;
  const { campusType } = role;

  const getNumber = () => {
    if (campusType === "UTM"){
      return "(905-569-4333)"
    } else if (campusType === "OTHER") {
      return ""
    }
    return "(416-978-2222)"
  };

  return (
    <EducationModuleLayout
      progressStage={4}
      childTitle="Refer"
      progressType="refer"
    >
      <section className="no-bottom-padding">
        <div className="container">
          <Row className="text-center">
            <Col xs={10} xsOffset={1}>
              <UnClickableScreenReader
                text={`An Exception to the Rule: Specific Safety Concerns Require Immediate Action`}
              />
              <h2 className="txt-blue no-bold no-margin">
                An Exception to the Rule: Specific Safety Concerns Require Immediate Action
              </h2>
            </Col>
          </Row>
          <Row>
            <Col xs={10} xsOffset={1}>
              <p>
                The exception to respecting autonomy is in situations where you believe that there is
                concern for someone’s safety. Recall in IDENTIFY, that there are certain Behaviours,
                Thoughts and Feelings that Raises Specific Safety Concern. These include:
              </p>
              <ul className="list-group">
                <li className="list-group-item">
                  vague or overt references to harming self or others
                </li>
                <li className="list-group-item">
                  vague or overt references to thoughts of suicide
                </li>
                <li className="list-group-item">
                  confusion, disorientation, apparent disconnect from reality
                  (written or verbal)
                </li>
                <li className="list-group-item">
                  expressions of hopelessness, helplessness, or worthlessness
                  (written or verbal)
                </li>
              </ul>
              <p>
                Concerns about anyone's safety at any time should be treated with urgency and would require a{' '}
                <span style={{ fontStyle: 'italic', fontWeight: 'bold' }}>more immediate connection or referral.</span>{' '}
                As soon as you can, inform someone who is in a position to act. This can include contacting campus{" "}
              <a href="https://mentalhealth.utoronto.ca/find-support-and-services/" target="_blank" aria-label="External link to health">
				health
              </a>
				{" "}centers, Campus Safety or
                Emergency Services (9-1-1). In these situations, it’s important to do this even when the person you are
                concerned about is unwilling to access these resources themselves. Make sure to protect your own safety
                in the process.
              </p>
            </Col>
          </Row>
        </div>
      </section>
      <section>
        <div className="container text-center">
          <Row>
            <Col xs={12}>
              <Button
                className="btn btn-blue previous"
                onClick={() => props.history.goBack()}
              >
                Previous
              </Button>
              <LinkContainer to={url.REFER_E} className="btn btn-blue next">
                <Button>Next</Button>
              </LinkContainer>
            </Col>
          </Row>
        </div>
      </section>
    </EducationModuleLayout>
  );
};

ReferPage.propTypes = {
  role: PropTypes.object.isRequired // eslint-disable-line react/forbid-prop-types
};

const ReferD = connect.role(ReferPage);

export default ReferD;



// WEBPACK FOOTER //
// ./src/containers/Refer/ReferD/index.jsx